import React from 'react';
import styled, { css } from 'styled-components';
import { useI18n } from '../i18n/index';
import { theme } from '../styles/theme';
import { fadeIn, withMotion } from '../styles/animations';

const VERSION = '0.3.0';

const AppFooter = () => {
  const { t } = useI18n();

  return (
    <Footer>
      <Inner>
        <FooterText>{t('footer.text')}</FooterText>
        <Right>
          <Version>
            {t('footer.version')} {VERSION}
          </Version>
        </Right>
      </Inner>
    </Footer>
  );
};

const Footer = styled.footer`
  margin-top: auto;
  border-top: 1px solid ${theme.colors.borderStrong};
  padding: ${theme.spacing.md} ${theme.spacing.xl};
  background: ${theme.colors.surfaceElevated};
  position: relative;
  z-index: 10;

  ${withMotion(css`
    animation: ${fadeIn} 0.5s ease both;
    animation-delay: 0.4s;
  `)}

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
  }
`;

const Inner = styled.div`
  max-width: 920px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.md};
  flex-wrap: wrap;
`;

const FooterText = styled.p`
  font-size: 11px;
  color: ${theme.colors.textMuted};
  letter-spacing: 0.3px;
  line-height: 1.5;
`;

const Right = styled.div`
  flex-shrink: 0;
`;

const Version = styled.span`
  font-size: 11px;
  color: ${theme.colors.textMuted};
  font-family: ${theme.typography.fontMono};
  letter-spacing: 0.5px;
`;

export default AppFooter;
